import { TFunction } from 'i18next';
import {
  IconBriefcase,
  IconCloudUpload,
  IconCpu,
  IconFileCheck,
  IconFilePlus,
  IconSend,
  IconUser,
} from '@tabler/icons-react';
import { RichSelectOption } from '@/components/Controls/RichSelect';
import { withoutEmptyOption } from '@/components/Custom/Filter/FilterKit';
import {
  ActionUserType,
  VehiculeCheckProgressStatus,
} from '@/api/entities/vehicule-check';
import {
  getOptionIndividualVehiculeCheckStatus,
  getOptionProVehiculeCheckStatus,
  getOptionsVehiculeCheckType,
} from '@/utils/constant.utils';

const ICON_PROPS = { size: 15, stroke: 2 };

const CLIENT_TYPE_ICONS: Record<string, React.ReactNode> = {
  [ActionUserType.PROFESSIONAL]: (
    <IconBriefcase {...ICON_PROPS} className="text-indigo-600" />
  ),
  [ActionUserType.INDIVIDUAL]: (
    <IconUser {...ICON_PROPS} className="text-amber-600" />
  ),
};

const PROGRESS_STATUS_ICONS: Record<string, React.ReactNode> = {
  [VehiculeCheckProgressStatus.REQUEST_CREATED]: (
    <IconFilePlus {...ICON_PROPS} className="text-slate-500" />
  ),
  [VehiculeCheckProgressStatus.REQUEST_CREATED_AND_SENT]: (
    <IconSend {...ICON_PROPS} className="text-indigo-600" />
  ),
  [VehiculeCheckProgressStatus.COMPLETED_STILL_WAITING_FOR_VIDEO]: (
    <IconCloudUpload {...ICON_PROPS} className="text-purple-F505DA/60" />
  ),
  [VehiculeCheckProgressStatus.COMPLETED_STILL_PROCESSING_VIDEO]: (
    <IconCpu {...ICON_PROPS} className="text-blue-20BDFF" />
  ),
  [VehiculeCheckProgressStatus.COMPLETED_REPORT_AVAILABLE]: (
    <IconFileCheck {...ICON_PROPS} className="text-green-11BFA4" />
  ),
};

const withIcons = (
  options: { label: string; value: string }[],
  icons: Record<string, React.ReactNode>,
): RichSelectOption[] =>
  withoutEmptyOption(options).map((option) => ({
    ...option,
    icon: icons[option.value],
  }));

/** "Pro" / "Individual" options of the inspection lists filters. */
export const getClientTypeFilterOptions = (t: TFunction<undefined>) =>
  withIcons(getOptionsVehiculeCheckType(t), CLIENT_TYPE_ICONS);

/** Progress status options ("making" column) of the inspection lists filters. */
export const getProgressStatusFilterOptions = (
  t: TFunction<undefined>,
  isRequestList?: boolean,
) =>
  withIcons(
    isRequestList
      ? getOptionIndividualVehiculeCheckStatus(t)
      : getOptionProVehiculeCheckStatus(t),
    PROGRESS_STATUS_ICONS,
  );
